import React, { Component } from "react";
import { PropTypes } from "prop-types";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import moment from "moment";
import Select from "react-select";

import DateTimePicker from "components/common/tools/DateTimePicker";
import ContainerHeader from "components/utils/ContainerHeader";
import Breadcrumbs from "components/utils/Breadcrumbs";
import { getSelectClassNames } from "../form/Select";

import "css/admin/freecopy.scss";

const containerHeaderLinks = {
  en: "https://support.okast.tv/en/support/solutions/articles/103000101749-gifts-management",
  fr: "https://support.okast.tv/fr/support/solutions/articles/103000101749-gestion-des-cadeaux-pour-vos-utilisateurs",
};

export class GiftAdminFormUI extends Component {
  constructor(props) {
    super(props);

    this.state = {
      shareMode: "email",
      offerMode: "sd",
      item: props.item,
    };
  }

  getFreecopyStatus = () => {
    const { item } = this.state;
    if (!item.email) return "waiting";

    const today = moment();
    const begin_date = moment(item.inserted_at);
    const end_date = moment(item.limit_date);

    if (today.isBefore(begin_date)) return "pause";

    if (today.isBetween(begin_date, end_date)) {
      return "active";
    }
    return "expired";
  };

  openModal = () => {
    this.setState({
      modalLangOpen: true,
    });
  };

  closeModal = () => {
    this.setState({
      modalLangOpen: false,
    });
  };

  save = () => {
    const { item } = this.state;
    this.props.onSubmit(item);
  };

  onShareMode = (mode) => {
    this.setState({
      shareMode: mode,
    });
  };

  onOfferMode = (mode) => {
    this.setState({
      offerMode: mode,
    });
  };

  onDateChange = (date) => {
    this.setState({
      item: {
        ...this.state.item,
        limit_date: moment(date).format(),
      },
    });
  };

  onEmailsChange = (event) => {
    this.setState({
      item: {
        ...this.state.item,
        email: event.target.value,
      },
    });
  };

  onDaysChange = (event) => {
    this.setState({
      item: {
        ...this.state.item,
        month_duration: event.target.value,
      },
    });
  };

  setLang = (lang) => {
    this.setState({
      item: {
        ...this.state.item,
        lang,
      },
    });
  };

  onOfferSelect = (selection) => {
    this.setState({
      item: {
        ...this.state.item,
        offer_uuid: selection.value,
      },
    });
  };

  render() {
    const { item } = this.state;
    const { t, editMode, onSubmit, project_uuid } = this.props;

    const current_offer = { value: item.offer_uuid, label: null };

    const offers = [];

    this.props.offers.map((it) => {
      if (it.uuid === item.offer_uuid) current_offer.label = it.label;

      if (it.storefront_project_uuid === project_uuid)
        offers.push({ value: it.uuid, label: it.label });
    });

    const breadcrumbs = [
      {
        name: t("editor-menu:offerManagement"),
        url: "/fregiftecopy",
      },
      {
        name: t("sectionTitleSimple"),
        url: "/gift",
      },
      {
        name: ` ${t(editMode ? "edit" : "new")}`,
      },
    ];

    const selectClassNames = getSelectClassNames();

    return (
      <div
        className="editor-container freecopy editor-has-breadcrumbs"
        data-testid="GiftAdminForm"
      >
        <Breadcrumbs items={breadcrumbs} />
        <ContainerHeader
          withBackBtn
          item={{
            ...item,
            label: editMode ? t("editLabel") : t("newLabel"),
          }}
          onSave={
            editMode
              ? () => {
                  onSubmit(this.state.item);
                }
              : null
          }
          infoLinks={containerHeaderLinks}
        />
        <div className="editor-tile-container">
          {this.state.shareMode === "tokens" ? (
            <div className="editor-form-section">
              <div className="editor-form-row">
                <div className="editor-form-label">{t("tokensNumber")}</div>
                <input id="tokensNumber" type="number" min={1} />
              </div>
            </div>
          ) : (
            <div className="editor-form-section">
              <div className="editor-form-row">
                <div className="editor-form-label">{t("emailAddress")}</div>
                <div className="editor-form-input">
                  <input
                    placeholder={t("emailAddressesPlaceholder")}
                    type="text"
                    onChange={this.onEmailsChange}
                    value={item.email}
                  />
                </div>
                {!editMode && (
                  <div className="editor-form-section editor-form-languages">
                    <div className="editor-form-row">
                      <div className="editor-form-label">
                        {t("chooseLanguage")}
                      </div>
                      <div className="editor-form-input">
                        <div
                          key="languages.en"
                          className="editor-form-language"
                        >
                          <div className="editor-form-language-name">
                            {t("languages:langs.en")}
                          </div>
                          <div
                            className="editor-form-language-default-wrapper"
                            onClick={() => this.setLang("en")}
                          >
                            {this.state.item.lang === "en" && (
                              <div className="editor-form-language-default" />
                            )}
                          </div>
                        </div>
                        <div
                          key="languages.fr"
                          className="editor-form-language"
                        >
                          <div className="editor-form-language-name">
                            {t("languages:langs.fr")}
                          </div>
                          <div
                            className="editor-form-language-default-wrapper"
                            onClick={() => this.setLang("fr")}
                          >
                            {this.state.item.lang === "fr" && (
                              <div className="editor-form-language-default" />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
          <div className="editor-form-section">
            <div className="editor-form-row">
              <div className="editor-form-label">{t("offer")}</div>
              <div className="editor-form-input max-w-100">
                <Select
                  classNames={selectClassNames}
                  onChange={this.onOfferSelect}
                  value={current_offer}
                  options={offers}
                  isSearchable
                  isDisabled={editMode}
                  classNamePrefix="gift-offer-select"
                />
              </div>
            </div>
          </div>
          <div className="editor-form-section">
            <div className="editor-form-row">
              <div className="editor-form-label">{t("freePeriod")}</div>
              <input
                id="freePeriod"
                type="number"
                min={1}
                disabled={editMode}
                value={this.state.item.month_duration}
                onChange={this.onDaysChange}
              />
              <span>&nbsp;{t("months")}</span>
            </div>
          </div>
          <div className="editor-form-section">
            <div className="editor-form-row">
              <div className="editor-form-label">{t("tokenExpiration")}</div>
              <DateTimePicker
                value={item.limit_date ? new Date(item.limit_date) : undefined}
                onDateTimeChange={this.onDateChange}
                minDate={new Date()}
              />
            </div>
          </div>
          {this.state.shareMode === "tokens" ? (
            <div className="editor-form-section">
              <button className="editor-btn">
                <span>{t("tokensDownload")}</span>
                <i className="material-icons">cloud_download</i>
              </button>
              <button className="editor-btn">
                <span>{t("tokensSend")}</span>
                <i className="material-icons">send</i>
              </button>
            </div>
          ) : (
            <div className="editor-form-section">
              {!editMode && (
                <button
                  className="editor-btn"
                  onClick={() => {
                    onSubmit(this.state.item);
                  }}
                >
                  <span>{t("emailsSend")}</span>
                  <i className="material-icons">send</i>
                </button>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}

GiftAdminFormUI.propTypes = {
  project_uuid: PropTypes.string,
  item: PropTypes.object.isRequired,
  offers: PropTypes.array.isRequired,
  onSubmit: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  editMode: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  offers: state.fetchReducer.offers.data,
  project_uuid: state.architectureReducer.project_uuid,
});

export default connect(mapStateToProps)(
  withTranslation(["editor-gift"])(GiftAdminFormUI),
);
